export default "__VITE_PUBLIC_ASSET__57278e70__"